import { SessionStorageKey } from '../enums/SessionStorageKey';

export function storeLoginData({ token, email }: { token: string; email: string }) {
  sessionStorage.setItem(SessionStorageKey.Token, token);
  sessionStorage.setItem(SessionStorageKey.Username, email);
}
